import React from 'react';
import { RuleSet } from 'styled-components';
import { Button } from '../../../ui/Button';

interface OperationButtonProps {
  onClickHandler: () => void;
  text: string;
  disabled?: boolean;
  styles?: RuleSet<object>;
}

export const OperationButton: React.FC<OperationButtonProps> = ({
  text,
  onClickHandler,
  disabled,
  styles
}) => (
  <Button
    text={text}
    onClick={onClickHandler}
    disabled={disabled}
    styles={styles}
    cypress="operation-button"
  />
);
